import type { CreditSourceType } from "@polifonia/interlude/billingConstants";
import dayjs from "dayjs";
import type { TFunction } from "i18next";

const DEFAULT_DATE_RANGE_DAYS = 14;
const MAX_DATE_RANGE_DAYS = 90;
const DATE_FORMAT = "YYYY-MM-DD";

export const getDefaultDateRange = (): {
  dateFrom: string;
  dateTo: string;
} => ({
  dateFrom: dayjs()
    .subtract(DEFAULT_DATE_RANGE_DAYS, "day")
    .format(DATE_FORMAT),
  dateTo: getMaxDate(),
});

export const getMinDate = (): string =>
  dayjs().subtract(MAX_DATE_RANGE_DAYS, "day").format(DATE_FORMAT);

export const getMaxDate = (): string => dayjs().format(DATE_FORMAT);

export interface TransactionFilters {
  dateFrom: string;
  dateTo: string;
}

export const TRANSACTION_TABLE_COLUMN_COUNT = 4;

export const getSourceTypeLabels = (
  t: TFunction,
): Record<CreditSourceType, string> => ({
  topup: t("billing.transaction.sourceType.topup"),
  manual_adjustment: t("billing.transaction.sourceType.manualAdjustment"),
  usage_settlement_item: t("billing.transaction.sourceType.usageSettlement"),
});
